const NativeDate = globalThis.Date;

let installed = false;

type DateArgs =
  | []
  | [string | number | Date]
  | [number, number, number?, number?, number?, number?, number?];

function parseLocalFakeTime(raw: string): Date {
  // Optional leading @ means libfaketime-style start-and-advance; strip for JS parse.
  const value = raw.startsWith('@') ? raw.slice(1) : raw;
  const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/.exec(value);
  if (match === null) {
    throw new Error(
      `Invalid VITE_FAKETIME "${raw}"; expected YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss`,
    );
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const hours = Number(match[4]);
  const minutes = Number(match[5]);
  const seconds = Number(match[6]);

  return new NativeDate(year, month - 1, day, hours, minutes, seconds);
}

export function resetDevFakeClockForTests(): void {
  globalThis.Date = NativeDate;
  installed = false;
}

export function installDevFakeClock(raw: string | undefined): void {
  if (raw === undefined || raw.trim() === '') {
    return;
  }
  if (installed) {
    return;
  }

  const target = parseLocalFakeTime(raw.trim());
  const offsetMs = target.getTime() - NativeDate.now();

  class DevFakeDate extends NativeDate {
    constructor(...args: DateArgs) {
      if (args.length === 0) {
        super(NativeDate.now() + offsetMs);
      } else if (args.length === 1) {
        super(args[0]);
      } else {
        const [year, monthIndex, date = 1, hours = 0, minutes = 0, seconds = 0, ms = 0] = args;
        super(year, monthIndex, date, hours, minutes, seconds, ms);
      }
    }

    static override now(): number {
      return NativeDate.now() + offsetMs;
    }
  }

  globalThis.Date = DevFakeDate as unknown as DateConstructor;
  installed = true;
}
